import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });

export default createStore({
  state: {
    user: null,
    saltKey: import.meta.env.VITE_SALT_KEY,
    geminiApiKey: null,
    schema: [], 
 demo: [], 
 images: [], 
 books: [], 
 questions: [], 
 settings: [], 
    users: [],
    contacts: [],
    tasks: [],
    mermaid: [],
    pages: []
  },
  mutations: {
    setUser(state, user) {
      console.log("user :>> ", user);
      state.user = user;
    },
    logoutUser(state) {
      state.user = null;
    },
    addContacts(state, contacts) { 
      state.contacts = [...contacts]; 
    }, 
    addSettings(state, settings) { 
 state.settings = [...settings]; 
}, 
 addQuestions(state, questions) { 
 state.questions = [...questions]; 
}, 
 addPages(state, pages) { 
 state.pages = [...pages]; 
}, 
 addBooks(state, books) { 
 state.books = [...books]; 
}, 
 addImages(state, images) { 
 state.images = [...images]; 
}, 
 addDemo(state, demo) { 
 state.demo = [...demo]; 
}, 
 addSchema(state, schema) {
      state.schema = [...schema];
    },
    addUsers(state, users) {
      state.users = [...users];
    },
    addTasks(state, tasks) {
      state.tasks = [...tasks];
    },
    addMermaid(state, mermaid) {
      state.mermaid = [...mermaid];
    },
    addMermaidItem(state, item) {
      state.mermaid.push(item);
    },
    updateMermaidItem(state, updatedItem) {
      const index = state.mermaid.findIndex(item => item.id === updatedItem.id);
      if (index !== -1) {
        state.mermaid.splice(index, 1, updatedItem);
      }
    },
    deleteMermaidItem(state, id) {
      state.mermaid = state.mermaid.filter(item => item.id !== id);
    },
    setGeminiApiKey(state, key) {
      state.geminiApiKey = key;
    }
  },
  getters: {
    _isAuthenticated: (state) => state.user !== null,
    _getCurrentUser(state) {
      const user = state.user;

      delete user?.password;
      return user;
    },
    _currentUserId: (state) => state?.user?.id,
    _getCurrentRole: (state) => parseInt(state?.user?.role),
    _saltKey: (state) => state.saltKey,
    _getContacts: (state) => state?.contacts, 
    _getSettings: (state) => state?.settings, 
 _getQuestions: (state) => state?.questions, 
 _getPages: (state) => state?.pages, 
 _getBooks: (state) => state?.books, 
 _getImages: (state) => state?.images, 
 _getDemo: (state) => state?.demo, 
 _getSchema: (state) => state?.schema,
    _getUsers: (state) => state?.users,
    _getTasks: (state) => state?.tasks,
    _getMermaid: (state) => state?.mermaid,
    _getGeminiApiKey: (state) => state?.geminiApiKey,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
